// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4beac114","77":"07062831","115":"ba25f6ef","222":"22024047","280":"f79ad31d","354":"47c4cd92","444":"31bd161e","523":"e5eafd50","526":"f1fde2a8","567":"a0cafc55","850":"b4e70e36","860":"490dd43a","928":"63b4930f"}[chunkId] + ".chunk.js";
};